import { useMemo } from 'react';
import {
  fieldsAndFriendlyLabelsList,
  sortByGroupOptions,
} from '@/pages/CandidateInfo/candidateInfoFields';
import { ValuesWithLabel } from '@/types';
import * as Styles from './CandidateSortBy.styles';

export type CandidateSortByProps = {
  onUpdateSortBy: (event) => void;
  column: string;
  sortByOptions?: ValuesWithLabel[];
  label?: string;
  isBigger?: boolean;
  outline?: boolean;
};

const CandidateSortBy = ({
  onUpdateSortBy,
  column,
  sortByOptions,
  label: dropdownLabel = 'Sort by',
  isBigger = true,
  ...dropdownProps
}: CandidateSortByProps): JSX.Element => {
  const sortByOptionsToUse = useMemo(() => {
    if (sortByOptions) {
      return sortByOptions;
    }

    const formatSortByOptions = ([value, label]: string[]): ValuesWithLabel => ({ value, label });
    const isFieldOnSortOptions = ([key]: string[]): boolean => sortByGroupOptions.includes(key);

    const sortByOptionsFiltered = fieldsAndFriendlyLabelsList.filter(isFieldOnSortOptions);
    const sortByOptionsFormatted = sortByOptionsFiltered.map(formatSortByOptions);

    return sortByOptionsFormatted;
  }, [sortByOptions]);

  return (
    <Styles.CustomDropdown
      label={dropdownLabel}
      name="column"
      isBigger={isBigger}
      {...dropdownProps}
      darkerLabel
      onChangeDropDown={onUpdateSortBy}
      defaultValue={column}
      optionsWithLabel={sortByOptionsToUse}
    />
  );
};

export default CandidateSortBy;
